<template>
  <b-card
    header-tag="header"
    :footer="record.tags | toSplit"
    footer-tag="footer"
    @click="targetClick"
    no-body
  >
    <b-card-header>
      <span>{{record.type}}</span>
      <span style="float: right;">
        <font-awesome-icon
          v-if="record.visibilidad == 'PUBLICO'"
          icon="globe-americas"
          v-b-popover.hover.top="'Recurso público'"
        />
        <font-awesome-icon
          v-if="record.visibilidad == 'PRIVADO'"
          icon="user-lock"
          v-b-popover.hover.top="'Recurso privado'"
        />
        <b-checkbox
          v-if="(!(record.author._id != $parent.user._id))"
          :checked="record.isChecked"
          class="chk-btn"
          name="checkbox-recursos"
          @change="recursosSelected($event,record)"
        ></b-checkbox>
      </span>
    </b-card-header>
    <b-col class="box pt-3 pb-3">
      <b-row class="flex-column">
        <b-col class="text-center">
          <slot></slot>
        </b-col>
        <b-col class="mt-1">
          <p v-if="$parent.user._id != record.author._id" class="autor-p">
            Autor:
            <strong>{{ record.author.nombreUsuario }}</strong>
          </p>
        </b-col>
        <b-col class="mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb m-0">
              <li class="breadcrumb-menu">
                <div class="btn-group" role="group" aria-label="Button group with nested dropdown">
                  <button                    
                    @click="btnClicked(button.id,record)"
                    class="btn btn-style"
                    v-for="button in buttons"
                    :key="button.id"
                    v-b-popover.hover.bottom="button.popover"
                    v-if="(!(record.author._id == $parent.user._id && button.id == 'btn_unshare')) && (!(record.author._id != $parent.user._id && button.id == 'btn-remove'))"
                  >
                    <font-awesome-icon
                      v-if="button.icon"
                      :icon="button.icon"
                      v-bind:class="[ record.compartido.includes($parent.user._id) && button.id == 'btn-share' ? 'fav' : '' ]"
                    />
                  </button>
                </div>
              </li>
            </ol>
          </nav>
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>
<style>
.fav {
  color: red;
}
.autor-p {
  margin-top: 20px;
  text-align: center;
}
.btn-style {
  padding: 8px !important;
}
h2 {
  padding: 15px;
}
.chk-btn {
  display: inline-block;
  margin-left: 10px;
}
</style>
<script>
export default {
  name: "block-content",
  props: {
    buttons: {
      type: Array,
      default: () => {
        return [];
      }
    },
    record: {
      type: Object,
      default: () => {
        return {};
      }
    },
    headerName: {
      type: String,
      default: "Record"
    },
    cardButton: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkedRecursosList: []
    };
  },
  methods: {
    recursosSelected: function(e, recurso) {
      console.log(recurso);
      var data = {
        checked: e,
        recurso: recurso
      };
      this.$emit("dataCheckedRecursos", data);
    },
    btnClicked: function(id, data) {
      if (id && data) {
        let emitter = {
          id: id,
          record: data
        };
        this.$emit("btnClicked", emitter);
      }
    },
    targetClick() {
      //console.log("target click emited");
      this.$emit("cardCliked");
    }
  },
  filters: {
    toSplit: function(value) {
      if (value.length > 0) {
        return value.join();
      }
    }
  }
};
</script>